module.exports = __webpack_public_path__ + "716436fb3df0d29e6b37dd62d952676a.png";